import { type FC, useCallback } from 'react';
import { useScrollCarousel } from 'dibs-scroll-carousel/exports/ScrollCarouselContext.ts';

import { PdpRespZoomModalLoader } from '../../PdpRespZoomModal/PdpRespZoomModalLoader.jsx';
import { THUMBS_VISIBLE } from './useThumbsPanel.ts';

import styles from './ZoomModal.module.css';

type ZoomMediaItem = {
    src: string | null;
    alt?: string | null;
    type?: string;
    thumbnail?: string | null;
    vimeoPlayerOptions?: {
        quality: string;
        id: string | null;
        tracking: $TSFixMe;
    };
};

export const ZoomModal: FC<{
    isOpen: boolean;
    onCloseClick: () => void;
    zoomMedia: ZoomMediaItem[];
    totalItems: number;
    title: string | null;
    image: string | null;
    itemId: string | null;
    userId: string | null;
    currency: string;
}> = ({ isOpen, onCloseClick, zoomMedia, totalItems, title, image, itemId, userId, currency }) => {
    const { activeSlide, setCurrentIndex } = useScrollCarousel();

    const onModalCloseClick = useCallback(
        ({ index }: $TSFixMe) => {
            onCloseClick();
            setTimeout(() => {
                setCurrentIndex(
                    totalItems > THUMBS_VISIBLE
                        ? {
                              index: index + THUMBS_VISIBLE,
                              backfillStartCount: THUMBS_VISIBLE,
                          }
                        : {
                              index,
                              backfillStartCount: 0,
                          }
                );
            }, 50);
        },
        [setCurrentIndex, onCloseClick, totalItems]
    );

    return title && image && itemId ? (
        <PdpRespZoomModalLoader
            relayVariables={{ itemId, fetchUser: !!userId, userId }}
            isOpen={isOpen}
            totalItems={totalItems}
            onCloseClick={onModalCloseClick}
            startingIndex={activeSlide - 1}
            zoomMedia={zoomMedia}
            display
            itemTitle={title}
            itemImage={image}
            itemId={itemId}
            currency={currency}
            modalClass={styles.zoomModal}
            hoverZoomWrapperClassName={styles.hoverZoomWrapper}
            hoverZoomInnerClassName={styles.hoverZoomInner}
        />
    ) : null;
};
